import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { buildUrl } from '../../Utils/Api';
import { AppSettings } from '../../Utils/Settings';

const base = 'verify'
export const verificationApi = createApi({
    reducerPath: 'verificationApi',
    baseQuery: fetchBaseQuery({
        baseUrl: AppSettings.ApiBaseUrl
    }),
    endpoints: (builder) => ({     
        postVerifyPhoneNumber: builder.mutation<any, {phoneNumber: string, consentSource: string}>({
            query: (body) => ({
                url: buildUrl(base, 'phone'),
                method: "POST",
                body
            })
        }),  
        postValidateCode: builder.mutation<any, {code: string, phoneNumber: string}>({
            query: (body) => ({
                url: buildUrl(base, 'validate'),
                method: "POST",
                body
            })
        }), 
    }),
})

export const {
    usePostValidateCodeMutation,
    usePostVerifyPhoneNumberMutation
} = verificationApi